import RepositoryFactory from '@/repository/RepositoryFactory';
const managerRepositories = RepositoryFactory.manager;

/**
 * 自身の情報を取得
 */
export async function getMe() {
  const response = await managerRepositories.me.index();
  return response.data.data;
}

export default {
  getMe,
};
